export const colors = {
    success: '#4caf50',
    error: '#e65100',
    info: '#3172b7',
    warn: '#ff9800',
};

export function lightenColor(hex: string, percent: number): string {
    // Remove o "#" se existir
    hex = hex.replace(/^#/, '');

    // Converte HEX para R, G, B
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Aplica o percentual para clarear (mistura com branco = 255)
    r = Math.min(255, Math.round(r + (255 - r) * (percent / 100)));
    g = Math.min(255, Math.round(g + (255 - g) * (percent / 100)));
    b = Math.min(255, Math.round(b + (255 - b) * (percent / 100)));

    // Retorna HEX formatado
    return `#${r.toString(16).padStart(2, '0')}${g
        .toString(16)
        .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
